export enum TITLE {
  CAMPAIGN_DETAILS = 'Campaign Details.',
  CAMPAIGN_VARIABLES = 'Campaign Variables.',
  WEEKLY_BUDGET_SPLIT = 'Weekly Budget Split.',
  CAMPAIGN_PLANNER = 'Campaign Plan.'
}

export enum SUBTITLE {
  STEP_ONE = 'Step 1',
  STEP_TWO = 'Step 2',
  STEP_THREE = 'Step 3',
  STEP_FOUR = 'Step 4'
}

export enum PARAGRAPH {
  PARAGRAPH_ONE = 'Define key campaign parameters. Discounts can be provided by your TVNZ Sales Rep or ',
  PARAGRAPH_TWO = 'Adjust key campaign parameters, peak percentages, station weights, day of week strategy and premium break positioning.',
  PARAGRAPH_THREE = 'Plan out your weekly activity across all months by either audience or budget, you can then define active weeks and their weightings.',
  PARAGRAPH_FOUR = 'All details of your plan, once you have submitted any campaign notes, you can download the PDF and then send it to your Commercial Operations contact.'
}

export const TVNZ_CONTACT_LINK = 'https://sales.tvnz.co.nz/contact-us/';
